import {setCacheNameDetails as workbox_core_setCacheNameDetails} from '/home/runner/work/cloudpilot-emu/cloudpilot-emu/web/node_modules/workbox-core/setCacheNameDetails.mjs';
import {clientsClaim as workbox_core_clientsClaim} from '/home/runner/work/cloudpilot-emu/cloudpilot-emu/web/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/home/runner/work/cloudpilot-emu/cloudpilot-emu/web/node_modules/workbox-precaching/precacheAndRoute.mjs';
import {cleanupOutdatedCaches as workbox_precaching_cleanupOutdatedCaches} from '/home/runner/work/cloudpilot-emu/cloudpilot-emu/web/node_modules/workbox-precaching/cleanupOutdatedCaches.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */





workbox_core_setCacheNameDetails({prefix: "cloudpilot-pwa"});


self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "1024.64c425e7f7148fbd.js",
    "revision": "3a03689698b43383c951f723219c9876"
  },
  {
    "url": "1273.981f3f5e3263a272.js",
    "revision": "b0d37e6aaebce0bff49aa91e7138bd5e"
  },
  {
    "url": "1411.1578c238843dfb83.js",
    "revision": "27aa8664f75535bb4cf91c617326e7c3"
  },
  {
    "url": "1479.e197eb49d61fbf81.js",
    "revision": "955a5c68a8927501f4637a0e1e2792a6"
  },
  {
    "url": "1603.bb20d4c68b2353e5.js",
    "revision": "80c1a5aea71cb180d74999420b3ae088"
  },
  {
    "url": "1735.e44ef9c1c2dbc2a8.js",
    "revision": "e0542f3892aba6897ff486330f2256fb"
  },
  {
    "url": "1769.2a4e98518c66afad.js",
    "revision": "5f56aa7acd905f87c175df6a35ee255e"
  },
  {
    "url": "198.de86e418f2641378.js",
    "revision": "7764aec693c42fca6369a92daedad98b"
  },
  {
    "url": "1981.3d1420e1c8a44df8.js",
    "revision": "1b685105bfdac603fd97472caa9797f3"
  },
  {
    "url": "2095.6083932644e02faf.js",
    "revision": "dd37b7efb04da501b51dd4ad1088a083"
  },
  {
    "url": "2273.e7faac9a6e0a7b03.js",
    "revision": "c5b0a8aa344503542129721d9cbf1f4f"
  },
  {
    "url": "2335.4e231df0d97f30db.js",
    "revision": "50ae0ff84c125a6c4378c94d1f80d900"
  },
  {
    "url": "2392.813cc0287db03be6.js",
    "revision": "1969aff976ff376c35c38ee093e8cf0e"
  },
  {
    "url": "2569.c671daef233832b7.js",
    "revision": "5f6321f22ed1a2ccbe3a854609c0b75f"
  },
  {
    "url": "3110.2a4e4dce6d4f0264.js",
    "revision": "24bca5882b76dc4a8b2b664ab6625b8f"
  },
  {
    "url": "3184.c8f5cadddb06f50f.js",
    "revision": "22077754017c16e68b8c6ab73c7c61ef"
  },
  {
    "url": "381.6f3cd4652e7af552.js",
    "revision": "77930c5a8357dc688727fb9823a3e4e0"
  },
  {
    "url": "388.3a3872c4fa0142fd.js",
    "revision": "f3ba5a710552317d54d8c96926b8fbe8"
  },
  {
    "url": "393.a4e63902ed9168fe.js",
    "revision": "97613e438ab1bf6f006ee1238ce5f8f5"
  },
  {
    "url": "4065.d2d6d757cc4cf817.js",
    "revision": "ca304877d06ca044822cb5d41af3bcd8"
  },
  {
    "url": "4248.5dcc6f20a35206fb.js",
    "revision": "28d63bb3e77dea6caf919d62c629753e"
  },
  {
    "url": "4312.f5352704a15476f3.js",
    "revision": "1fcba09baaaf318170416c7caa504a65"
  },
  {
    "url": "4540.9fd63dc18b7d7b77.js",
    "revision": "737ca07767d10946a74d85c43fa6b07e"
  },
  {
    "url": "4639.acde3f97f7617d28.js",
    "revision": "80a69bebd1a42870d60f589c3b205fd1"
  },
  {
    "url": "469.9caba480edd48853.js",
    "revision": "c87d67b2e8ab91e9d3feaa4126c941da"
  },
  {
    "url": "4810.81462a7a2351e8b9.js",
    "revision": "6a0d7145909b4d927b422a67806d293d"
  },
  {
    "url": "5196.1643afc9b2f20529.js",
    "revision": "856c6f36ce48659e6aa39fca087ae910"
  },
  {
    "url": "5297.9c8fd71ec38e21bc.js",
    "revision": "1245a589f7724f6a49f7944a717848e4"
  },
  {
    "url": "5427.eee9335918b7356f.js",
    "revision": "89ca3311c18d8d6469626ab07d9d2b27"
  },
  {
    "url": "5458.8aa3b245d146d0f7.js",
    "revision": "2202cd2ba03910c7e741d374062f750d"
  },
  {
    "url": "5575.876745e80bf3e8fd.js",
    "revision": "8fb5d795299f13d013fb6087f3db78bc"
  },
  {
    "url": "5678.180937c5ce4c9926.js",
    "revision": "93c903cb7d0f77bca165bd22a294474b"
  },
  {
    "url": "6034.68179b3830f7fb2c.js",
    "revision": "7846ba925c216836ba8cf1f71f6f6ca9"
  },
  {
    "url": "6059.d316173d9da8a58f.js",
    "revision": "ac81f733a7c2b1a1d1f79ab739c509ac"
  },
  {
    "url": "628.af4487d868607c10.js",
    "revision": "d76158e6617ef1b68943b8d62ac38bfb"
  },
  {
    "url": "6492.d2024cdd1b5f8f56.js",
    "revision": "407f07276c28292b85c312a26120cf74"
  },
  {
    "url": "6534.daeeb730a908a8ed.js",
    "revision": "31892b1ac20761262feec02c94a9d59a"
  },
  {
    "url": "654.a9621c259e56a283.js",
    "revision": "929d8a330a142d81fe3773c59beaba73"
  },
  {
    "url": "6772.231c0f08035e9625.js",
    "revision": "09e8fd462f77ebe9c613f086ea018226"
  },
  {
    "url": "6948.ecea7fae894fbc65.js",
    "revision": "ec15419fb5ee368091289beb0ec1d826"
  },
  {
    "url": "7101.5791e7a757c4cfb7.js",
    "revision": "bd11437b77952c069175f26f91af40bd"
  },
  {
    "url": "7184.f18868ffbb91c68c.js",
    "revision": "9d08d596be6e0b82fb3b1f3c2f3fb52c"
  },
  {
    "url": "7510.72064c5082d0e9a6.js",
    "revision": "ef496a780dcb892aa016913b847b7fff"
  },
  {
    "url": "7518.091563ada8e7511a.js",
    "revision": "233db2f51d5066bf76e6cb5e0b14f6a9"
  },
  {
    "url": "761.d43c70e9b21034fe.js",
    "revision": "fd9e3050e8971ba19269b28394824ddb"
  },
  {
    "url": "7971.bc10b20b4f4fba1d.js",
    "revision": "b2f3d9d50600292143f91aeca46a167e"
  },
  {
    "url": "8185.1e4ced93bf01a79a.js",
    "revision": "e5d41e1a65698671da8f74082875586d"
  },
  {
    "url": "8221.24c14aaf5c875b46.js",
    "revision": "c07c109a6130b0af3e3dec0fc5418192"
  },
  {
    "url": "8353.c51b7e87cb3df34e.js",
    "revision": "363009273ef9b86bc10b341e1ed4388e"
  },
  {
    "url": "8404.95622fee7c4bc5b9.js",
    "revision": "dd8164f545b04d324e7b658849d8602f"
  },
  {
    "url": "8442.fe0d61532ec4b35c.js",
    "revision": "a1dafa4706631c65dc9f64ec7d80b56a"
  },
  {
    "url": "8471.65f673a335e7e66f.js",
    "revision": "b02f34fef078460485057ba28ca96f8c"
  },
  {
    "url": "852.9c466ead79aeef7a.js",
    "revision": "9fe6be4094dd9caa4f636c59979276a6"
  },
  {
    "url": "8759.17b341e95974cf38.js",
    "revision": "30518b16df6d22b6ba463c51a4377b34"
  },
  {
    "url": "9160.24b0d307dac6f05a.js",
    "revision": "80ab56cc94771b691883c3ad2656098b"
  },
  {
    "url": "9528.1cc98f08a0db241a.js",
    "revision": "3097664bd30470cfdaa7f43eaab0c123"
  },
  {
    "url": "9557.ee8f0fe0b6b3db54.js",
    "revision": "0c140180cd4b25bde7ba607c8972d8d9"
  },
  {
    "url": "9642.04e008c42db37ebb.js",
    "revision": "6a917f406afaca2fdbafeca70ea13015"
  },
  {
    "url": "9863.2ec6d32404b5886e.js",
    "revision": "9debfce2a851999df39a663b1f694704"
  },
  {
    "url": "common.96573f9f8c1c9427.js",
    "revision": "0aa179d8f6d768da7d020fc7db351ee9"
  },
  {
    "url": "main.b0a957a3d7a79036.js",
    "revision": "423811bf08b6a91912721b7c277528e0"
  },
  {
    "url": "pcm-worklet.d75f25ad42c99afd.js",
    "revision": "fb8953c4ef3842116a8b3f14239a0d25"
  },
  {
    "url": "polyfills.8eea4612cf7389fb.js",
    "revision": "358abe3725901f963257022759b50110"
  },
  {
    "url": "runtime.38c1ec6d58138714.js",
    "revision": "8e65a64cacff4aff7369e76093bcce7d"
  },
  {
    "url": "uarm-worker.24552d9b8878a1c7.js",
    "revision": "28c4b67043a7379044c1683385f25fe8"
  },
  {
    "url": "index.html",
    "revision": "0f9e9c91029bfe9ec1ce12a01a893dda"
  },
  {
    "url": "wasm/cloudpilot_web-1b34cb3bb34490cb.wasm",
    "revision": "85a8a0036294e8cdf08df70bd43e2b22"
  },
  {
    "url": "wasm/fstools_web-54549856be05008d.wasm",
    "revision": "0d41f6ff44dea295a3115d34ac9121d7"
  },
  {
    "url": "wasm/uarm_web_optimized-01ac60345fbed1e4.wasm",
    "revision": "70506b16dd78a6aea297c0f69417feff"
  },
  {
    "url": "wasm/vfs_web-762804350aae2722.wasm",
    "revision": "bba3bf636ca830cec05a0c8add4570ee"
  },
  {
    "url": "manifest.webmanifest",
    "revision": "494c72dcbbc38f85fc522cc531fe9005"
  },
  {
    "url": "styles.5fbf357d007f9285.css",
    "revision": "059d8513e0e16a9b6ea326e885eba3a5"
  },
  {
    "url": "assets/doc/about-f1aa2e673050029b.md",
    "revision": "410c4479f7d4a76c9f8147e8a08f5890"
  },
  {
    "url": "assets/doc/card-browser-5a0261814255810d.md",
    "revision": "e1e775da5e0aaff009d08dfe2b41a79e"
  },
  {
    "url": "assets/doc/cards-75195154c07dfe52.md",
    "revision": "e543043fdb34409117903db5e67c48c5"
  },
  {
    "url": "assets/doc/CHANGELOG-f5d8a21cad7ac6b2.md",
    "revision": "a46d0e83f7b35127017ea62f42cd9a39"
  },
  {
    "url": "assets/doc/emulation-57fd091f66800f1c.md",
    "revision": "a6ced191eddc3c387cc2acb2080f46f2"
  },
  {
    "url": "assets/doc/sessions-ed6015592b559fd6.md",
    "revision": "160f15ac83f373c2d0c2238ce4e1568d"
  },
  {
    "url": "assets/doc/settings-c4c685caeeeded72.md",
    "revision": "6943727c6840fc4437481c5911683b74"
  },
  {
    "url": "assets/logo.svg",
    "revision": "db21c26a607b3bc270b93f88cbfa3dad"
  },
  {
    "url": "assets/shapes.svg",
    "revision": "e535ce83da20a4b7719ca3d45195ebd5"
  },
  {
    "url": "assets-pwa/apple-icon-180.png",
    "revision": "ed668876c413a89a4377abafd31b117a"
  },
  {
    "url": "assets-pwa/apple-splash-1125-2436.jpg",
    "revision": "248fcca65f6ad990df7359c98ef1053a"
  },
  {
    "url": "assets-pwa/apple-splash-1136-640.jpg",
    "revision": "6f2a516574b82a61f25808231ede2f82"
  },
  {
    "url": "assets-pwa/apple-splash-1170-2532.jpg",
    "revision": "f615f054e134d95baa0ff7cfa25d3d3f"
  },
  {
    "url": "assets-pwa/apple-splash-1179-2556.jpg",
    "revision": "5c7e29f4e0507108114922ac85b46ce4"
  },
  {
    "url": "assets-pwa/apple-splash-1206-2622.jpg",
    "revision": "4a133e839e50ca638b25607289ff750f"
  },
  {
    "url": "assets-pwa/apple-splash-1242-2208.jpg",
    "revision": "862d08cadc98cc479da1ecaf7fdac832"
  },
  {
    "url": "assets-pwa/apple-splash-1242-2688.jpg",
    "revision": "a2ea442966709ba66345cb6e41f029dd"
  },
  {
    "url": "assets-pwa/apple-splash-1284-2778.jpg",
    "revision": "6c829dd1269d04ae527234acb59eb6f5"
  },
  {
    "url": "assets-pwa/apple-splash-1290-2796.jpg",
    "revision": "9a557f4e328b50e3e947a0d62932792e"
  },
  {
    "url": "assets-pwa/apple-splash-1320-2868.jpg",
    "revision": "73d8b57f58060226bbdeb996c11fadab"
  },
  {
    "url": "assets-pwa/apple-splash-1334-750.jpg",
    "revision": "62ea67b0467b1725cd0f41f17437b563"
  },
  {
    "url": "assets-pwa/apple-splash-1488-2266.jpg",
    "revision": "d2f190a2063d414962c8750892cb8012"
  },
  {
    "url": "assets-pwa/apple-splash-1536-2048.jpg",
    "revision": "12b6ed4bc5bb0d896e6558de8d82c6c5"
  },
  {
    "url": "assets-pwa/apple-splash-1620-2160.jpg",
    "revision": "ed64d5ff8da2d55f98693aafefbe7253"
  },
  {
    "url": "assets-pwa/apple-splash-1640-2360.jpg",
    "revision": "bae89578f78198f8627ba7537cb2be12"
  },
  {
    "url": "assets-pwa/apple-splash-1668-2224.jpg",
    "revision": "8d8190d5f0ea42057c479fcd2d32744f"
  },
  {
    "url": "assets-pwa/apple-splash-1668-2388.jpg",
    "revision": "680fe94ddb5fbf161f1f26e67d1ec9fd"
  },
  {
    "url": "assets-pwa/apple-splash-1792-828.jpg",
    "revision": "eb047ca96514eb3336d5bfa4d6f1985f"
  },
  {
    "url": "assets-pwa/apple-splash-2048-1536.jpg",
    "revision": "3e34ac5b03dc6bddd5139cb913c96fef"
  },
  {
    "url": "assets-pwa/apple-splash-2048-2732.jpg",
    "revision": "4231bd132447724bfa1c3dfa35557dba"
  },
  {
    "url": "assets-pwa/apple-splash-2160-1620.jpg",
    "revision": "2cb531076c78c700fc7250eedc1b3b81"
  },
  {
    "url": "assets-pwa/apple-splash-2208-1242.jpg",
    "revision": "43ff6c372f7ad56ec1261173d5e6c53f"
  },
  {
    "url": "assets-pwa/apple-splash-2224-1668.jpg",
    "revision": "d7fed81b9443539b6cb03234ad277cab"
  },
  {
    "url": "assets-pwa/apple-splash-2266-1488.jpg",
    "revision": "f7aeeca9d78f690a1f649f4377485987"
  },
  {
    "url": "assets-pwa/apple-splash-2360-1640.jpg",
    "revision": "3590dd19fd0e9a81879062141d0fc163"
  },
  {
    "url": "assets-pwa/apple-splash-2388-1668.jpg",
    "revision": "415b75d52d9346be9d600af7f2ffc0e5"
  },
  {
    "url": "assets-pwa/apple-splash-2436-1125.jpg",
    "revision": "91a72a031ff1d8cabae532b7e6d8d826"
  },
  {
    "url": "assets-pwa/apple-splash-2532-1170.jpg",
    "revision": "955671c643c29017300ae250889fb78d"
  },
  {
    "url": "assets-pwa/apple-splash-2556-1179.jpg",
    "revision": "c8f0765fc098ba616e686fe687ac9482"
  },
  {
    "url": "assets-pwa/apple-splash-2622-1206.jpg",
    "revision": "41a11379e71231718004524c35434139"
  },
  {
    "url": "assets-pwa/apple-splash-2688-1242.jpg",
    "revision": "e46484178fbf3e92426a58ac9eef709d"
  },
  {
    "url": "assets-pwa/apple-splash-2732-2048.jpg",
    "revision": "e879ad12665a988a335443f8af3a5ebc"
  },
  {
    "url": "assets-pwa/apple-splash-2778-1284.jpg",
    "revision": "97eeb8f540265472050a59a8194caedd"
  },
  {
    "url": "assets-pwa/apple-splash-2796-1290.jpg",
    "revision": "c94b2443aefaddd34979b7458aed27c0"
  },
  {
    "url": "assets-pwa/apple-splash-2868-1320.jpg",
    "revision": "a306065ff6afcfe37d55558e75011685"
  },
  {
    "url": "assets-pwa/apple-splash-640-1136.jpg",
    "revision": "f23558535b50d91f6fc80c5f53e5c083"
  },
  {
    "url": "assets-pwa/apple-splash-750-1334.jpg",
    "revision": "242ee5041e42a2026d2042744ffaaa8b"
  },
  {
    "url": "assets-pwa/apple-splash-828-1792.jpg",
    "revision": "37e934c5ffe325653db8476ac2a925c2"
  },
  {
    "url": "assets-pwa/apple-splash-dark-1125-2436.jpg",
    "revision": "aaecde03cce2ce1fc54b0993b8340e30"
  },
  {
    "url": "assets-pwa/apple-splash-dark-1136-640.jpg",
    "revision": "81bccfc67ac68886ec1c6ab63891017c"
  },
  {
    "url": "assets-pwa/apple-splash-dark-1170-2532.jpg",
    "revision": "c2cb6368e7682772639c296842e4ac6b"
  },
  {
    "url": "assets-pwa/apple-splash-dark-1179-2556.jpg",
    "revision": "bdffbe2792f4894131cb653704722008"
  },
  {
    "url": "assets-pwa/apple-splash-dark-1206-2622.jpg",
    "revision": "1c1ebfc30c3ad303673c9cfe98ea4c8a"
  },
  {
    "url": "assets-pwa/apple-splash-dark-1242-2208.jpg",
    "revision": "8a7244270feddb9529fa7b98d26c6947"
  },
  {
    "url": "assets-pwa/apple-splash-dark-1242-2688.jpg",
    "revision": "2ef53d41bef52fcde9c5618a231d05c4"
  },
  {
    "url": "assets-pwa/apple-splash-dark-1284-2778.jpg",
    "revision": "5b3ce69f21ca844ac595c51b007eafe4"
  },
  {
    "url": "assets-pwa/apple-splash-dark-1290-2796.jpg",
    "revision": "a136fac59b005f479a77ba3815bd6036"
  },
  {
    "url": "assets-pwa/apple-splash-dark-1320-2868.jpg",
    "revision": "bc65949a1b930efede31ac13cc530ff9"
  },
  {
    "url": "assets-pwa/apple-splash-dark-1334-750.jpg",
    "revision": "e322889a173820cd34513e7b270e79a6"
  },
  {
    "url": "assets-pwa/apple-splash-dark-1488-2266.jpg",
    "revision": "4a574c2580c578431b06baae8cd60e9e"
  },
  {
    "url": "assets-pwa/apple-splash-dark-1536-2048.jpg",
    "revision": "41521401c98c988a0a3be7b721b2f2de"
  },
  {
    "url": "assets-pwa/apple-splash-dark-1620-2160.jpg",
    "revision": "8087769bc416a8717b110023d9104dee"
  },
  {
    "url": "assets-pwa/apple-splash-dark-1640-2360.jpg",
    "revision": "b6035143feab2de803d17a3968866bcf"
  },
  {
    "url": "assets-pwa/apple-splash-dark-1668-2224.jpg",
    "revision": "bb3944665808a2b3980c3234eae41e65"
  },
  {
    "url": "assets-pwa/apple-splash-dark-1668-2388.jpg",
    "revision": "7f106269dbeeb57dbc5e7dd01d2cc0f4"
  },
  {
    "url": "assets-pwa/apple-splash-dark-1792-828.jpg",
    "revision": "3e4ffeb351e1e8ca2f82f764bfb3af77"
  },
  {
    "url": "assets-pwa/apple-splash-dark-2048-1536.jpg",
    "revision": "2d1bdc8d65aa7098374eba4300075fe4"
  },
  {
    "url": "assets-pwa/apple-splash-dark-2048-2732.jpg",
    "revision": "4312dcb93f283efce212ab12f9b681dc"
  },
  {
    "url": "assets-pwa/apple-splash-dark-2160-1620.jpg",
    "revision": "a0c4e975e2ee7f4c757798a5c5e11986"
  },
  {
    "url": "assets-pwa/apple-splash-dark-2208-1242.jpg",
    "revision": "2023448cacde3d28197c276a7ac831a3"
  },
  {
    "url": "assets-pwa/apple-splash-dark-2224-1668.jpg",
    "revision": "b6188e18f6fe7289f35b9307a3e7c564"
  },
  {
    "url": "assets-pwa/apple-splash-dark-2266-1488.jpg",
    "revision": "377a2f55835d69ec3edf445349b718ad"
  },
  {
    "url": "assets-pwa/apple-splash-dark-2360-1640.jpg",
    "revision": "48ccb79249e374a66a59268fd17f2c6e"
  },
  {
    "url": "assets-pwa/apple-splash-dark-2388-1668.jpg",
    "revision": "f016a9b4f9865000da5c4a07e970247d"
  },
  {
    "url": "assets-pwa/apple-splash-dark-2436-1125.jpg",
    "revision": "d9ffa5d9df591a722800c093e9925910"
  },
  {
    "url": "assets-pwa/apple-splash-dark-2532-1170.jpg",
    "revision": "3e7c9f67d8c3c8bcb9fca2577a45a737"
  },
  {
    "url": "assets-pwa/apple-splash-dark-2556-1179.jpg",
    "revision": "cd754ab5f9328c4ad55c6835ffeb7a5c"
  },
  {
    "url": "assets-pwa/apple-splash-dark-2622-1206.jpg",
    "revision": "97251c214919082e1c4c18bf3b9d3e4f"
  },
  {
    "url": "assets-pwa/apple-splash-dark-2688-1242.jpg",
    "revision": "a4d644d7c5ac25bb82660982587682c9"
  },
  {
    "url": "assets-pwa/apple-splash-dark-2732-2048.jpg",
    "revision": "0cad761a2e54a6079d9a5003cc667ba5"
  },
  {
    "url": "assets-pwa/apple-splash-dark-2778-1284.jpg",
    "revision": "38055f887305aaf9db26e4e72d371209"
  },
  {
    "url": "assets-pwa/apple-splash-dark-2796-1290.jpg",
    "revision": "4b46c75bd38d82c9aa52bd66ee0735c0"
  },
  {
    "url": "assets-pwa/apple-splash-dark-2868-1320.jpg",
    "revision": "727254fdcb100b8671afaaa0d81f2a02"
  },
  {
    "url": "assets-pwa/apple-splash-dark-640-1136.jpg",
    "revision": "d486e9c49db501955f5009a6b022c755"
  },
  {
    "url": "assets-pwa/apple-splash-dark-750-1334.jpg",
    "revision": "325e02d23d403697a1b9e2cdf58b35d0"
  },
  {
    "url": "assets-pwa/apple-splash-dark-828-1792.jpg",
    "revision": "6408dc06288e991266027ff75837a594"
  },
  {
    "url": "assets-pwa/favicon-196.png",
    "revision": "d2c6e171b56b59ff9ebb6c7f73b555b9"
  },
  {
    "url": "assets-pwa/manifest-icon-192.maskable.png",
    "revision": "ea1e95bb54ca86773168dc65a3fa6caa"
  },
  {
    "url": "assets-pwa/manifest-icon-192.png",
    "revision": "2760427c0009ec090d560ee0f9c5a170"
  },
  {
    "url": "assets-pwa/manifest-icon-512.maskable.png",
    "revision": "25541acf313a3fd1e5a169b07190a4c0"
  },
  {
    "url": "assets-pwa/manifest-icon-512.png",
    "revision": "231ed098646cb9744d98d500d17854c1"
  },
  {
    "url": "svg/add-outline.svg",
    "revision": "5671eb6cbaa31f59e316e93fe3ff58af"
  },
  {
    "url": "svg/albums-outline.svg",
    "revision": "56b3251e70798f0a9a0b9151eac148df"
  },
  {
    "url": "svg/apps-outline.svg",
    "revision": "154a6cf4fbbdab1a4ad07b41c3670cf4"
  },
  {
    "url": "svg/checkmark-circle-outline.svg",
    "revision": "6e6de6b02909ff6d36d55e266470a28a"
  },
  {
    "url": "svg/chevron-back.svg",
    "revision": "b2edec3a21e414d9a4206a76d2b8f9cd"
  },
  {
    "url": "svg/clipboard-outline.svg",
    "revision": "e648da09d5b620cdf3e5fd6de18b7c25"
  },
  {
    "url": "svg/cog-outline.svg",
    "revision": "9cb8c07c8043a3196882bcff6bd1e086"
  },
  {
    "url": "svg/copy-outline.svg",
    "revision": "04f36e25fd969e4cd59e38791c1cddcf"
  },
  {
    "url": "svg/create-outline.svg",
    "revision": "ed4e05bc72d223d44fb305039f8eaabe"
  },
  {
    "url": "svg/cut-outline.svg",
    "revision": "c46c90a208f053ad8aa3c5faa244a6e3"
  },
  {
    "url": "svg/document-outline.svg",
    "revision": "bc9b6b0f94919bda3e7ddde0b04ed84c"
  },
  {
    "url": "svg/download-outline.svg",
    "revision": "d68ced28c94f6118749c6a09d103933b"
  },
  {
    "url": "svg/ellipsis-vertical-outline.svg",
    "revision": "1144dae5fabc466c3c4f2f1758bd70d7"
  },
  {
    "url": "svg/eye-off-outline.svg",
    "revision": "2e90acfb4e9e7ab6a8a8eceaee9c0207"
  },
  {
    "url": "svg/file-tray-outline.svg",
    "revision": "b8d7db9a63b378e9afdcea6fd8e939e7"
  },
  {
    "url": "svg/folder-outline.svg",
    "revision": "eb0fc1df3c56345f0e82d162dadf6d8a"
  },
  {
    "url": "svg/game-controller-outline.svg",
    "revision": "d8850c14f81e0f5e5e9ad3b6f485bbee"
  },
  {
    "url": "svg/help-outline.svg",
    "revision": "f77d4c4a686e3458a88a48091eca8552"
  },
  {
    "url": "svg/list-outline.svg",
    "revision": "c355fa010b0e756be54b9f2debae082a"
  },
  {
    "url": "svg/lock-closed-outline.svg",
    "revision": "21d4615575982b51cf6cf981f0a0b870"
  },
  {
    "url": "svg/lock-open-outline.svg",
    "revision": "9b8508727f6f010cd227d618b752686f"
  },
  {
    "url": "svg/log-in-outline.svg",
    "revision": "a85d11f3b887f44bc8368ce2bb82c8fb"
  },
  {
    "url": "svg/log-out-outline.svg",
    "revision": "37f5f7e2641fa1395bf77bf5042bff33"
  },
  {
    "url": "svg/medkit-outline.svg",
    "revision": "8533760b5ca5fad937d58b06af57346a"
  },
  {
    "url": "svg/phone-portrait-outline.svg",
    "revision": "12a297ae5c4728439e78d1be1ee15489"
  },
  {
    "url": "svg/power-outline.svg",
    "revision": "aa52141c9b3571850b340f2c25af64c9"
  },
  {
    "url": "svg/radio-button-off-outline.svg",
    "revision": "935284de298afb682a9ad6739330beae"
  },
  {
    "url": "svg/radio-button-on-outline.svg",
    "revision": "e5bc858d4c2e791ac038fd18005a67e5"
  },
  {
    "url": "svg/refresh-outline.svg",
    "revision": "e1a63657873d114f1d4238b02eec8703"
  },
  {
    "url": "svg/reload-outline.svg",
    "revision": "9354b0b6d3727b35f017d65f7ca5f91d"
  },
  {
    "url": "svg/share-outline.svg",
    "revision": "a7474556820b8cf0518016f5dac1b798"
  },
  {
    "url": "svg/speedometer-outline.svg",
    "revision": "21ed47ad575b921d1f555a3bfa9f38eb"
  },
  {
    "url": "svg/swap-vertical-outline.svg",
    "revision": "c4a31a6d1843632fbc7f967642b99069"
  },
  {
    "url": "svg/sync-outline.svg",
    "revision": "cc0a29885bad34c3e8cb760d6c89218b"
  },
  {
    "url": "svg/trash-outline.svg",
    "revision": "49e6e9865110cbd445eeca0a84fceaaf"
  },
  {
    "url": "svg/volume-high-outline.svg",
    "revision": "395267271e6c7f62fa6e6ec017ea1d88"
  },
  {
    "url": "svg/volume-mute-outline.svg",
    "revision": "f1faba0d1afb46c277634ce21e21e29a"
  },
  {
    "url": "svg/camera-outline.svg",
    "revision": "6f2bd5e944cd9acab60e5915a3cee14f"
  },
  {
    "url": "svg/logo-google-playstore.svg",
    "revision": "8de673b42937538e3d05c2cccd4df79f"
  },
  {
    "url": "svg/logo-apple-appstore.svg",
    "revision": "b3f3361d47f597540b1a8d5306370338"
  }
], {});
workbox_precaching_cleanupOutdatedCaches();







